import React, { useMemo, useState } from "react";
import "./patient-search.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getPatients,
  resetAllPatients,
} from "../../../store/slices/patientSlice";
import { dateFormat, resolveActingDoctorId } from "../../../utils/common-funtions/common";

const PatientSearch = ({
  setSelectedTabOption,
  setIsNewUser,
  setSinglePatientInfo,
  singlePatientInfo,
  selectedTabOption,
  height = 100,
  buttonName,
  isNewUser,
  useFlexHeight = false,
  className = "",
}) => {
  const dispatch = useDispatch();
  let { isLoading, allPatients, noPatientFound } = useSelector(
    (state) => state.patient
  );
  const { user, selectedRole, selectedDoctor } = useSelector((state) => state.auth);
  const actingDoctorId = resolveActingDoctorId({ user, selectedRole, selectedDoctor });
  const [key, setKey] = useState("patientId")
  const [inputValue, setInputValue] = useState()
  const showPatientFun = (e) => {
    e.preventDefault();
    if (e.target.value?.length >= 2)
      dispatch(getPatients({ search: e.target.value, key: key, doctorId: actingDoctorId }));
    else if (e.target.value?.length <= 1) {
      dispatch(resetAllPatients());
      setSinglePatientInfo({});
      setIsNewUser(true);
    }
    setInputValue(e.target.value)
  };

  const setKeyFun = (value) => {
    setInputValue("")
    setKey(value)
  }

  useMemo(() => {
    if (isNewUser) {
      if (document.getElementById("patient-search"))
        document.getElementById("patient-search").value = "";
      dispatch(resetAllPatients());
    }
  }, [isNewUser]);

  return (
    <div
      className={`patient-search-section-appointment ${className}`.trim()}
      style={useFlexHeight ? { height: "100%", minHeight: 0 } : { height: `${height}vh` }}
    >
      <div className="patient-search-section-appointment__shell">
        <div className="patient-search-section-appointment__head">
          <p className="patient-search-section-appointment__title">
            Find patient
          </p>
          <p className="patient-search-section-appointment__hint">
            {key === "dob"
              ? "Pick a date to search."
              : "Enter at least 2 characters to search."}
          </p>
        </div>

        <div className="patient-search-section-appointment__controls">
          <div className="patient-search-section-appointment__toolbar">
            <span className="patient-search-section-appointment__toolbar-label">
              Search by
            </span>
            <select
              className="patient-search-section-appointment__toolbar-select"
              aria-label="Search field"
              onChange={(e) => {
                setKeyFun(e.target.value);
              }}
              value={key}
            >
              <option value="patientId">Patient ID</option>
              <option value="name">Name</option>
              <option value="phone">Phone</option>
              <option value="dob">Date of birth</option>
            </select>
          </div>
          <div className="patient-search-section-appointment__field">
            <input
              onChange={(e) => showPatientFun(e)}
              placeholder={
                key === "dob" ? "Select date" : `Type ${key}…`
              }
              type={key === "dob" ? "date" : "text"}
              id="patient-search"
              autoComplete="off"
              value={inputValue || ""}
              className="search-input patient-search-section-appointment__input"
            />
          </div>
        </div>

        <div className="search-result-section patient-search-section-appointment__results">
          <div className="table-responsive patient-search-section-appointment__table-wrap">
            <table
              id="patient-search-results"
              className="table table-sm patient-search-section-appointment__table mb-0"
            >
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Phone</th>
                  <th scope="col">DOB</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td
                      colSpan={4}
                      className="patient-search-section-appointment__status"
                    >
                      Searching…
                    </td>
                  </tr>
                ) : (
                  <>
                    {allPatients?.map((patient, index) => (
                      <tr
                        key={patient?._id || index}
                        className={
                          patient?._id === singlePatientInfo?._id
                            ? "patient-search-section-appointment__row patient-search-section-appointment__row--active"
                            : "patient-search-section-appointment__row"
                        }
                        onClick={() => {
                          setIsNewUser(false);
                          setSinglePatientInfo(patient);
                        }}
                      >
                        <td className="patient-search-section-appointment__cell-id">
                          {patient?.patientId}
                        </td>
                        <td className="patient-search-section-appointment__cell-name">
                          {patient?.name}
                        </td>
                        <td>{patient?.phone}</td>
                        <td>{dateFormat(patient?.dob?.slice(0, 10))}</td>
                      </tr>
                    ))}
                    {allPatients?.length === 0 && noPatientFound && (
                      <tr>
                        <td
                          colSpan={4}
                          className="patient-search-section-appointment__status"
                        >
                          No patient found
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientSearch;
